import { WebPortalService } from "../resource";
import swal from "sweetalert2";
import i18n from "./i18n";

const CdrModule = {
  namespaced: true,
  state: {
    cdr: [],
    dashboard: null,
    dashboardNumber: null,
    dashboardGroup: null,
	waiting : false,
  },
  mutations: {
    SET_CDR(state, data) {
      state.cdr = data;
    },
    SET_DASHBOARD(state, data) {
      state.dashboard = data;
    },
    SET_DASHBOARD_NUMBER(state, data) {
      state.dashboardNumber = data;
    },
    SET_DASHBOARD_GROUP(state, data) {
      state.dashboardGroup = data;
    }
  },
  actions: {
    initReport({ commit }) {
      commit("SET_CDR", null);
      commit("SET_DASHBOARD_NUMBER", null);
      commit("SET_DASHBOARD_GROUP", null);
      commit("SET_DASHBOARD", null);
    },
    async listCdr({ commit, state }, params) {
		swal.fire({
			title: i18n.t(`processing`),
			type: "info",
			showCancelButton: true,
			showConfirmButton: false,
			cancelButtonText: i18n.t(`close`),
		});

      try {
        const resp = await WebPortalService.ReportCdr(params);
		commit("SET_CDR", resp.data == null ? null : resp.data.Data);

		if (resp.data.Status == "ok"){
			swal.close()
		}

      } catch (err) {
        console.log(err);
        swal.fire({
          title: i18n.t(err.response.data.Msg),
          icon: "error",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-info btn-fill"
        });
      }
    },
    // async listDashboardNumber({ commit, state }, params) {
    //   const data = await WebPortalService.ReportDashboardNumber(params);
    //   if (data.data == null) {
    //     commit("SET_DASHBOARD_NUMBER", null);
    //   } else {
    //     commit("SET_DASHBOARD_NUMBER", data.data.Data[0]);
    //   }
    // },
    // async listDashboardGroup({ commit, state }, params) {
    //   const data = await WebPortalService.ReportDashboardGroup(params);

    //   if (data.data == null) {
    //     commit("SET_DASHBOARD_GROUP", null);
    //   } else {
    //     commit("SET_DASHBOARD_GROUP", data.data.Data[0]);
    //   }
    // },
    async listDashboard({ commit, state }, params) {

		if (state.waiting == false) {
			swal.fire({
				title: i18n.t(`processing`),
				type: "info",
				showCancelButton: true,
				showConfirmButton: false,
				cancelButtonText: i18n.t(`close`),
			});
		}

      try {
		state.waiting = true
		console.log("module request")
        const resp = await WebPortalService.ReportDashboard(params);
        commit("SET_DASHBOARD", resp.data.Data == null ? null : resp.data.Data[0]);

		if (resp.data.Status == "ok"){
		console.log("module response ok",resp)
			state.waiting = false
			swal.close()
		} else {

		console.log("module response",resp)
		}
      } catch (err) {
        console.log("module error",err);
		state.waiting = false
        swal.close()
        swal.fire({
          title: i18n.t(err.response.data.Msg),
          icon: "error",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-info btn-fill"
        });
      }
    }
  },
  getters: {
    getCdr(state) {
      return state.cdr;
    },
    getDashboardNumber(state) {
      return state.dashboardNumber;
    },
    getDashboardGroup(state) {
      return state.dashboardGroup;
    },
    getDashboard(state) {
      return state.dashboard;
    },
    isWaiting(state) {
      return state.waiting;
    }
  }
};

export default CdrModule;
